import React from "react";
import { Box } from "@mui/material";

const ToolsLayer = ({ watchType, isMaximized, ...props }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#1e1e1e55",
        opacity: watchType === "listen" || isMaximized ? 1 : 0,
        transition: "opacity 0.2s",
        "&:hover": {
          opacity: 1,
        },
      }}
    >
      {props.children}
    </Box>
  );
};

export default ToolsLayer;
